/*  ========================================================================
    # Sections - History Timeline
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import bem from '@/react/utils/bem';
import HistoryTimelineEntry from './HistoryTimelineEntry';

const HistoryTimeline = ({ headline, years }) => {
  return (
    <>
      <div className='container'>
        {headline ? (
          <div className='tw-w-full lg:tw-w-8/12 tw-mx-auto'>
            <div
              className='s-history-timeline__headline wysiwyg-block'
              dangerouslySetInnerHTML={{ __html: headline }}
            ></div>
          </div>
        ) : null}
        <div className={bem('s-history-timeline', 'slider')}>
          <div className='s-history-timeline__line'>
            <div className='s-history-timeline__line-dots'></div>
          </div>
          {years.map((year, index) => (
            <HistoryTimelineEntry
              key={index}
              year={year.year}
              title={year.title}
              description={year.description}
              image={year.image}
            />
          ))}
        </div>
      </div>
    </>
  );
};

HistoryTimeline.propTypes = {
  headline: PropTypes.string,
  years: PropTypes.array
};

export default HistoryTimeline;
